import React, { useEffect, useState } from 'react';
import { AlertFilters } from '../AlertFilters';
import { EnhancedModal } from 'module-tsl-ui-modal';
import { Button } from 'module-tsl-ui-elements';
  
const SaveSearchBtn = (props) => {
  const { i18n, mapsApiKey, id, searchDetails, isMobile } = props;
  const [openModal, setOpenModal] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [closeWarning, setCloseWarning] = useState(false);
  const [newId, setNewId] = useState(id);
  const [savedFacets, setSavedFacets] = useState(searchDetails);

  const onChange = (message, savedId, facets) => {
    switch(message) {
      case 'Cancel': {
        setCloseWarning(false);
        break;
      }
      case 'Close': {
        setCloseWarning(false);
        setOpenModal(false);
        break;
      }
      case 'Saved': {
        setIsSaved(true);
        setNewId(savedId);
        setSavedFacets(facets);
        break;
      }
      case 'NotSaved': {
        setIsSaved(false);
        break;
      }
    }
  };

  const onModalOpen = () => {
    setOpenModal(true);
    setCloseWarning(false);
    setIsSaved(false);
  };

  const onModalClose = () => {
    if(newId) {
      setOpenModal(false);
    } else {
      setCloseWarning(true);
    }
  };

  useEffect(() => {
    setSavedFacets(searchDetails);
    setNewId(id);
  }, [searchDetails, id]);

  const title = id ? 'Edit your alert' : "This is your new alert";
  const subTitle = isSaved
    ? "You can view and edit all of your job alerts in your Job alerts page."
    : "We will send you email alerts with any new jobs that match your filters.";

  return (
    <div>
      <Button onClick={onModalOpen}>{newId ? 'Edit alert' : 'Create alert'}</Button>
      <p>{openModal}</p>
      <EnhancedModal
        showModal={openModal}
        onHideModal={onModalClose}
        title={ isSaved ? "Congratulations, your job alert is all set." : title }
        subtitle={ isMobile ? '' : subTitle }
        icon="tds-bookmark"
      >
        <AlertFilters 
          key={closeWarning}
          id={id}
          editing={true}
          searchDetails={savedFacets}
          onAlertChange={onChange}
          i18n={i18n}
          mapsApiKey={mapsApiKey}
          fromSearch
          isCanceled={closeWarning}
        />
      </EnhancedModal>
    </div>
  );
};

export default SaveSearchBtn;
